import React, { useEffect, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, getRemotedbUrl, isAppOld } from '../../../lib/ep.js';
import { useOwner } from '../../context/context.js';

import ActionButton from '../../builder/ActionButton';
import ActionLink from '../../builder/ActionLink';
import ButtonCollection from '../../builder/ButtonCollection';
import Checkbox from '../../builder/Checkbox';
import FloatingLayer from '../../builder/FloatingLayer';
import Message, { AlertMessage } from '../../builder/Message';
import Model from '../../builder/Model';
import SectionTitle from '../../builder/SectionTitle';
import Spinner from '../../builder/Spinner';
import SectionSubtitle from '../../builder/SectionSubtitle.js';

const CopyOptions = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;

	const promotion_type = props?.promotion_type ?? false;
	const has_emails = props?.has_emails ?? true;
	const has_codesets = props?.has_codesets ?? true;
	const has_hashtag_integrations = props?.has_hashtag_integrations ?? true;
	const has_custom_domain = props?.has_custom_domain ?? true;
	const skip_actions = props?.skip_actions ?? false;
	
	const default_options = {
		prizes:!skip_actions ? true : false,
		platform:promotion.promo_type,
		copy_emails:false,
	};
	if(promotion.promotion_type_id == '13') default_options.users = true;

	const [ copy_options, setCopyOptions ] = useState(default_options);
	const [ display_layer, setDisplayLayer ] = useState(false);
	const [ progress, setProgress ] = useState(false);

	const [ recommended_type, setRecommendedType ] = useState(false);
	
	const is_old_type = (isAppOld(promotion.promotion_type_id)) ? true : false;

	const old_promo_link = '20264497867284';

	useEffect(() => {
		if(!is_old_type) return;

		let recommended_type_id = false;
		switch(promotion.promotion_type_id) {
			case '2':
			case '3':
			case '4':
				recommended_type_id = '45';
				break;
		}

		if(recommended_type_id !== false) {
			$.get(`/utils/promotion_types`, (res) => {
				if(res == '' || res == undefined) return;

				setRecommendedType(res.find((pt) => (pt.id == recommended_type_id)));
			}, 'JSON');
		}
	}, []);

	if(promotion === false) return null;

	const changeOptions = (k, v) => {
		if(k == 'change_to_wl') {
			k = 'platform';
			v = (v === true) ? '2' : '1';
		}

		setCopyOptions({ ...copy_options, [k]:v });
	};

	const copy = (copy_props) => {
		if(copy_props == undefined) copy_props = copy_options;

		setDisplayLayer(false);
		setProgress(true);

		$.post(getRemotedbUrl(`/promotions/copyPromotion/${promotion.id}`), copy_props, (r) => {
			setProgress(false);
			if(props.onCopy != undefined){
				props.onCopy(r);
			}else{
				window.location.href =  getRemotedbUrl(r.url);
			}
		}, 'JSON');
	};

	const copyNewTemplate = () => {
		const copy_props = { ...copy_options, premium_template:'1' };
		setCopyOptions(copy_props);
		copy(copy_props);
	};

	const close = () => {
		setDisplayLayer(false);
		setProgress(false);
	};

	const is_obsolete_template = (promotion.template_id == '1') ? true : false;

	const login_enabled = promotion?.multi_participation ?? false;
	const allow_stages = (promotion_type !== false && promotion_type.allow_stages != '0') ? true : false;
	const dislay_login_warning = (!login_enabled && allow_stages) ? true : false;

	const enable_copy_promo = (EPDateBefore(null, '2021-02-01 00:00:00') || (promotion.promo_type != '0' || promotion.promotion_type_id == '1')) ? true : false;

	const type = props?.type ?? 'link';
	const Component = (type == 'button') ? ActionButton : ActionLink;

	const main_label = props?.main_label ?? "copy promotion";
	const main_title = props?.main_title ?? "copy promotion";
	const main_description = props?.main_description ?? false;
	const main_button = props?.main_button ?? "copy promotion";

	return (
		<>
			<Component
				onClick={() => setDisplayLayer(true)}
				icon={props?.without_icon ?? 'knk-copy'}
				_class={{ other:'copyPromo' }}
				autotranslate={false}
			>{i18n(main_label, 'ucfirst')}</Component>

			{(progress) && (
				<FloatingLayer enable_close={false}>
					<div>
						<Spinner
							force_bg={true}
							autotranslate={false}
						>Copying promotion. Please, wait.</Spinner>
					</div>
				</FloatingLayer>
			)}

			{(display_layer !== false && enable_copy_promo) && (
				<FloatingLayer _class={{ size:'small' }} backButton={close}>
					<div>
						<SectionTitle autotranslate={false}>{i18n(main_title, 'ucfirst')}</SectionTitle>
						{(main_description) && (
							<SectionSubtitle>{main_description}</SectionSubtitle>
						)}
						{(is_old_type) && (
							<AlertMessage
								icon={false}
								_class={{ other:'in_top' }}
							>
								<p>
									<strong>
										<FormattedMessage
											id="The {type} application is old."
											values={{ type:`"${i18n(promotion_type.name)}"` }}
										/>
									</strong>
								</p>

								{(recommended_type !== false) && (
									<p>
										<FormattedMessage
											id="We recommend you to use the new application {type} instead."
											values={{ type:`"${i18n(recommended_type.name)}"` }}
										/>
									</p>
								)}

								<p>
									<ActionLink
										_href={`${window.zendesk_base_url}${old_promo_link}`}
										_target='_blank'
									>More information</ActionLink>
								</p>
							</AlertMessage>
						)}

						{(is_obsolete_template) && (
							<AlertMessage
								title="Important notice"
								_class={{ other:'in_top' }}
							>
								<p>{i18n("As of 1st October 2018, this promotion design became obsolete. It's been replaced with a new, more modern template. When you copy this promotion, the new template will be applied.")}</p>
							</AlertMessage>
						)}

						{(dislay_login_warning) && (
							<AlertMessage
								title="Important notice"
								_class={{ other:'in_top' }}
							>
								<p><strong>{i18n("This promotion uses an old version of the platform")}.</strong></p>
								<p>{i18n("We recommend that you create a new promotion of the same type, to use the most current version of the platform.")}</p>
							</AlertMessage>
						)}
						
						{(!skip_actions) && (
							<Model model={copy_options} change={(k, v) => changeOptions(k, v)}>
								<Checkbox name="prizes" _class={{first:true}}>Copy the prizes to the new promotion</Checkbox>

								<Checkbox name="copy_emails">Copy emails to the new promotion</Checkbox>

								{(promotion.promo_type == '1') && (
									<Checkbox name="change_to_wl" value={((copy_options?.platform ?? '1') == '2') ? true : false}>Copy the promotion with White Label features (upgrade)</Checkbox>
								)}
							</Model>
						)}

						{(!skip_actions && has_emails && copy_options.copy_emails) && (
							<Message
								icon='knk-send'
								_class={{ other:'gui_not_in_top_small in_bottom' }}
							>
								<p><strong>{i18n("Emails will be copied but will be disabled.")}</strong></p>
								<p>{i18n("You will need to check and enable them again.")}</p>
							</Message>
						)}

						{(!skip_actions && has_codesets) && (
							<Message
								icon='knk-promotional-code'
								_class={{ other:'gui_not_in_top_small in_bottom' }}
							>
								<p><strong>{i18n("Code sets will be copied but without any code.")}</strong></p>
								<p>{i18n("You must upload the new codes.")}</p>
							</Message>
						)}

						{(!skip_actions && has_hashtag_integrations) && (
							<Message
								icon='knk-hashtag'
								_class={{ other:'gui_not_in_top_small in_bottom' }}
							>
								<p><strong>{i18n("Instagram and Twitter integrations will not be copied.")}</strong></p>
								<p>{i18n("You must connect them again.")}</p>
							</Message>
						)}

						{(!skip_actions && has_custom_domain) && (
							<Message
								icon='knk-networks'
								_class={{ other:'gui_not_in_top_small in_bottom' }}
							>
								<p><strong>{i18n("Custom Domain itself will not be copied.")}</strong></p>
								<p>{i18n("You will have to configure it again.")}</p>
							</Message>
						)}

						<ButtonCollection in_floating={true}>
							{(!is_obsolete_template) ? (
								<ActionButton
									onClick={() => copy()}
									autotranslate={false}
								>{i18n(main_button, 'ucfirst')}</ActionButton>
							) : (
								<ActionButton
									onClick={() => copyNewTemplate()}
								>Copy with new template</ActionButton>
							)}
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{(display_layer && !enable_copy_promo) && (
				<FloatingLayer _class={{size:'small'}} backButton={close}>
					<div>
						<AlertMessage
							title="You cannot do a copy of this promotion"
							_class={{ other:'in_top' }}
						>
							<p><FormattedMessage id="The competition type {type} is no longer supported with Basic version." values={{type:((promotion_type !== false) ? '"' + i18n(promotion_type.name) + '"' : "[" + i18n("Unknown type") + "]")}} /></p>
							<p><strong>{i18n("Please create a new one from scratch.")}</strong></p>
						</AlertMessage>

						<ButtonCollection in_floating={true}>
							<ActionButton
								_href={`${window.panel_url}promotions/type_selector`}
							>Create a new promotion</ActionButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

export default injectIntl(CopyOptions);